import { getTimezoneDayjs } from './time';

type TimeGroup<T> = {
  title: string;
  items: T[];
};

const getTimeGroup = (date: DateString): string => {
  const now = getTimezoneDayjs();
  const itemDate = getTimezoneDayjs(date);
  const diffDays = now.diff(itemDate, 'day');
  const diffYears = now.diff(itemDate, 'year');

  if (diffDays === 0) return 'Today';
  if (diffDays <= 7) return 'Previous 7 days';
  if (diffDays <= 30) return 'Last 30 days';
  if (diffYears === 0) return itemDate.format('MMMM');
  return itemDate.format('YYYY');
};

export const groupByTime = <
  T extends { created_at: string },
  K extends keyof T,
>(
  items: T[],
  key: K,
): TimeGroup<T>[] => {
  const groups: { [key: string]: T[] } = {};

  items.forEach((item) => {
    const date = item[key] as DateString;
    if (!date || typeof date !== 'string') {
      console.error(`Invalid date: ${date}`);
      return;
    }
    const group = getTimeGroup(date);
    if (!groups[group]) {
      groups[group] = [];
    }
    groups[group].push(item);
  });

  return Object.entries(groups).map(([title, items]) => ({
    title,
    items,
  }));
};
